import { services } from '../../../mocks/services';

export default function Services() {
  return (
    <section id="services" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">
            專業花藝服務
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            從日常花束到大型活動佈置，我們提供全方位的花藝設計服務
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-[#FAFAFA] rounded-2xl p-6 sm:p-8 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-[#14B8A6] rounded-2xl mb-5 sm:mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>

              <h3 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">
                {service.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed mb-4 sm:mb-5">
                {service.description}
              </p>

              <ul className="space-y-2 sm:space-y-3">
                {service.features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-2 sm:gap-3">
                    <i className="ri-check-line text-[#14B8A6] text-base sm:text-lg mt-0.5 flex-shrink-0"></i>
                    <span className="text-xs sm:text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
